import { PricingState } from '../types';

export const createPricingState = (): PricingState => ({
  seoLimitations: undefined,
  unsplashImagesLimitations: undefined
});
